/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WaterGraph
 */
export interface WaterGraph {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the WaterGraph interface.
 */
export function instanceOfWaterGraph(value: object): value is WaterGraph {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function WaterGraphFromJSON(json: any): WaterGraph {
  return WaterGraphFromJSONTyped(json, false);
}

export function WaterGraphFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaterGraph {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function WaterGraphToJSON(json: any): WaterGraph {
  return WaterGraphToJSONTyped(json, false);
}

export function WaterGraphToJSONTyped(
  value?: WaterGraph | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
